import { Button } from '@pets-ui/Button/Button'
import { CartFilled } from '@pets-ui/Icons'
import { useHistory } from 'react-router-dom-v5'

interface GoToCartFooterActionProps {
  basePath: string
}

export const GoToCartFooterAction = (props: GoToCartFooterActionProps) => {
  const { basePath } = props
  const history = useHistory()

  return (
    <Button color="red" startIcon={<CartFilled />} onClick={() => history.push(`${basePath}/cart`)}>
      前往購物車
    </Button>
  )
}
